import { Component, OnInit } from '@angular/core';
import { slideInAnimation } from './route-animation';
//import { PushNotificationService } from './servicios/push-notification.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [slideInAnimation]
})
export class AppComponent {
  //export class AppComponent implements OnInit {
    mesaggeReceived = '';
  title = 'Fiscalización';
 /*  constructor(private notificacion: PushNotificationService) {
    notificacion.requestPermission().then(token => {
      console.log(token);
    })
  } */
 

} 
